import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { uniqueId } from '../../lib/uniqueId';
import {
  SweepNotification,
  addNotification,
  updateNotification,
  removeNotification,
  clearNotifications,
} from '../../reducers/notificationsReducer';

export const useSweepNotifications = () => {
  const dispatch = useDispatch();

  const _addNotification = useCallback(
    ({
      variant,
      message,
      action,
      keepOpen,
      details,
      linkUrl,
      linkText,
      linkOpenInNewTab,
      position,
      theme,
      autoHideDuration,
    }: Pick<
      SweepNotification,
      | 'variant'
      | 'message'
      | 'action'
      | 'keepOpen'
      | 'details'
      | 'linkUrl'
      | 'linkText'
      | 'linkOpenInNewTab'
      | 'position'
      | 'theme'
      | 'autoHideDuration'
    >) => {
      const key = uniqueId();
      const sweepNotification: SweepNotification = {
        key,
        variant,
        message,
        action,
        keepOpen,
        details,
        linkUrl,
        linkText,
        linkOpenInNewTab,
        position,
        theme,
        autoHideDuration,
      };
      dispatch(addNotification(sweepNotification));
      return key;
    },
    [dispatch],
  );

  const _updateNotification = useCallback(
    (key: string, updates: Partial<Omit<SweepNotification, 'key'>>) => {
      dispatch(updateNotification({ key, updates }));
    },
    [dispatch],
  );

  const _removeNotification = useCallback(
    (key: string) => {
      dispatch(removeNotification(key));
    },
    [dispatch],
  );

  const _clearNotifications = useCallback(() => {
    dispatch(clearNotifications());
  }, [dispatch]);

  return {
    addNotification: _addNotification,
    updateNotification: _updateNotification,
    removeNotification: _removeNotification,
    clearNotifications: _clearNotifications,
  };
};
